/* global axios */
import ApiClient from './ApiClient';

class KnowledgeBaseDocumentsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  index(agentBotId) {
    return axios.get(`${this.url}/${agentBotId}/knowledge_base_documents`);
  }

  createFromFile(agentBotId, { file, name }) {
    const formData = new FormData();
    formData.append('file', file);
    if (name) {
      formData.append('name', name);
    }
    return axios.post(
      `${this.url}/${agentBotId}/knowledge_base_documents`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  createFromText(agentBotId, { name, content }) {
    return axios.post(`${this.url}/${agentBotId}/knowledge_base_documents`, {
      name,
      content,
    });
  }

  delete(agentBotId, documentId) {
    return axios.delete(
      `${this.url}/${agentBotId}/knowledge_base_documents/${documentId}`
    );
  }

  approve(agentBotId, documentId) {
    return axios.post(
      `${this.url}/${agentBotId}/knowledge_base_documents/${documentId}/approve`
    );
  }
}

export default new KnowledgeBaseDocumentsAPI();
